import {WechatInitOptions, WechatTextMsg, WechatFileMsg} from "../../base/options";
import * as rp from "request-promise";
import {WechatService} from "../wechatservice";
import {AppTokenService} from "../../token/apptokenservice";
import {TokenService} from "../../token/tokenservice";

/**
 * 企业微信 消息 服务
 */
export class MessageService {

  /*
   * 发送文本消息
   * */
  static async sendTextMsg(msg: WechatTextMsg): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}message/send?access_token=${accessToken}`,
      body: {
        "msgtype": "text",
        "agentid": msg.agentId,
        "text": {
          "content": msg.content
        },
        "safe": msg.safe || 0
      },
      json: true
    };

    if (msg.toUser) {
      param.body.touser = msg.toUser;
    }
    if (msg.toParty) {
      param.body.toparty = msg.toParty;
    }
    if (msg.toTag) {
      param.body.totag = msg.toTag;
    }

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`send text message failed , response:`);
      console.error(result);
    }

    return "";
  }

  /*
   * 发送文件消息
   * */
  static async sendFileMsg(msg: WechatFileMsg): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}message/send?access_token=${accessToken}`,
      body: {
        "msgtype": "file",
        "agentid": msg.agentId,
        "file": {
          "media_id": msg.mediaId
        },
        "safe": msg.safe || 0
      },
      json: true
    };

    if (msg.toUser) {
      param.body.touser = msg.toUser;
    }
    if (msg.toParty) {
      param.body.toparty = msg.toParty;
    }
    if (msg.toTag) {
      param.body.totag = msg.toTag;
    }

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`send file message failed , response:`);
      console.error(result);
    }

    return "";
  }

  /**
   * 发送markdown语法消息
   * @param msg
   */
  static async sendMarkdownMsg(msg: WechatTextMsg): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}message/send?access_token=${accessToken}`,
      body: {
        "msgtype": "markdown",
        "agentid": msg.agentId,
        "markdown": {
          "content": msg.content
        },
        "safe": msg.safe || 0
      },
      json: true
    };

    if (msg.toUser) {
      param.body.touser = msg.toUser;
    }
    if (msg.toParty) {
      param.body.toparty = msg.toParty;
    }
    if (msg.toTag) {
      param.body.totag = msg.toTag;
    }

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`send text message failed , response:`);
      console.error(result);
    }

    return "";
  }

}
